import { InvalidStateError } from '#common/types';
import { createFileStore } from './file-store-impl';
export const getFileStoreBuilder = (fileStoreWasm, fileNodeManager) => {
    return new FileStoreBuilder(fileStoreWasm, fileNodeManager);
};
class FileStoreBuilder {
    fileStoreWasm;
    fileNodeManager;
    blockStoreStack = [];
    constructor(fileStoreWasm, fileNodeManager) {
        this.fileStoreWasm = fileStoreWasm;
        this.fileNodeManager = fileNodeManager;
    }
    addStage(factory) {
        this.blockStoreStack.push(factory(this.blockStoreStack.at(-1)));
    }
    build() {
        if (this.blockStoreStack.length === 0) {
            throw new InvalidStateError('No stages added');
        }
        const fileStore = createFileStore(this.fileStoreWasm, this.fileNodeManager, this.blockStoreStack.reverse());
        return fileStore;
    }
}
